import { AnalysisIssuePersonMultiEventConflict } from '@hefe/models';
import IssueEventBlockComponent from '../issue-event-block/issue-event-block.component';
import IssueUserBlockComponent from '../issue-user-block/issue-user-block.component';

interface IssuePersonMultiEventConflictBodyComponentProps {
  issue: AnalysisIssuePersonMultiEventConflict;
}

export default function IssuePersonMultiEventConflictBodyComponent(
  props: IssuePersonMultiEventConflictBodyComponentProps
) {
  const { issue } = props;
  return (
    <>
      <IssueUserBlockComponent user={issue.context.user} />

      <IssueEventBlockComponent event={issue.context.event_1} />
      <IssueEventBlockComponent event={issue.context.event_2} />
    </>
  );
}
